export const footerData = [
  {
    title: 'à propos',
    list: [
      {
        label: 'RGPD',
        link: 'RGPD',
      },
      {
        label: 'Conditions générales',
        link: 'CGV',
      },
      {
        label: 'Mentions légales',
        link: 'mentions_legales',
      },
    ],
  },
  {
    title: 'entreprise',
    list: [
      {
        label: 'Espace commercial',
        link: '/login/commercial',
      },
      {
        label: 'Modalités de référencement',
        link: 'referencement',
      },
    ],
  },
  {
    title: 'acheteurs publics',
    list: [
      {
        label: 'Accès acheteur public ',
        link: '/login/acheteurs',
      }
    ],
  },
  {
    title: 'support',
    list: [
      // {
      //   label: 'FAQ',
      //   link: '#'
      // },
      {
        label: 'Nous contacter',
        link: 'contact',
      },
    ],
  },
];
